import Main from "../components/layout/Main";
import ProtectedRoute from "../components/comps/protected_route";
import AuditTrail from "../pages/audit/AuditTrail";

const auditRoutes = [
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <Main />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "audit/trail",
        element: (
          <ProtectedRoute>
            <AuditTrail />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default auditRoutes;
